import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';
import {
    ProjectCheckpoints,
    TasksModel,
} from '../../../../domain/projectCheckpoints/projectCheckpoints';
import EmployeeSelector from '../../../employees/components/EmployeeSelector';
import DateField from '../../../shared/components/forms/DateField';
import TextField from '../../../shared/components/forms/TextField';
import TextAreaField from '../../../shared/components/forms/TextAreaField';

interface Props {
    projectCheckpoint: ProjectCheckpoints;
    onChange: (
        name: string,
        value: string | boolean | number[] | number | undefined | TasksModel[]
    ) => void;
    onAddTask: (task: TasksModel) => void;
}

export default function ProjectCheckpointTasksSection({
    onAddTask,
    onChange,
    projectCheckpoint,
}: Props) {
    const initialValue = {
        id: 0,
        employeeId: 0,
        consultant: '',
        task: '',
        status: 0,
        estimatedDate: '',
        comments: '',
    };
    const [errorMessage, setErrorMessage] = useState('');
    const [task, setTask] = useState<TasksModel>(initialValue);

    const handleInputChange = (
        name: string,
        value: string | boolean | number[] | number | undefined
    ) => {
        setTask({ ...task, [name]: value });
    };

    useEffect(() => {
        if (
            task.employeeId > 0 &&
            task.task !== '' &&
            task.estimatedDate !== '' &&
            task.comments !== ''
        ) {
            setErrorMessage('');
        } else {
            setErrorMessage('Ingresa todos los campos correctamente');
        }
    }, [task]);

    const handlerAddTask = () => {
        onAddTask(task);
        setTask(initialValue);
    };

    const handleRemoveTask = (indexToRemove: number) => {
        const updatedTasks = [...projectCheckpoint.tasks];
        updatedTasks.splice(indexToRemove, 1); // Elimina el elemento en el índice especificado
        onChange('tasks', updatedTasks); // Actualiza el estado de las tareas
    };

    return (
        <div className='row py-2 p-5 gap-2'>
            <div className='row col-7'>
                <h5 className=''>Nueva Tarea</h5>
                <div className='col-6'>
                    <EmployeeSelector
                        onChange={handleInputChange}
                        name={`employeeId`}
                        value={task.employeeId}
                    />
                </div>

                <div className='col-6'>
                    <DateField
                        label='Fecha Estimada'
                        name={`estimatedDate`}
                        onChange={handleInputChange}
                        required={false}
                        value={task.estimatedDate}
                        key='estimatedDate'
                    />
                </div>

                <div className='col-6'>
                    <TextField
                        label='Tarea'
                        name={'task'}
                        onChange={handleInputChange}
                        required={false}
                        value={task.task}
                    />
                </div>
                <div className='col-12'>
                    <TextAreaField
                        name='comments'
                        value={task.comments}
                        label='Comentarios'
                        required={false}
                        onChange={handleInputChange}
                        key='comments'
                    />
                </div>

                <div className='col-12'>
                    <button
                        className='btn btn-primary '
                        onClick={handlerAddTask}
                        disabled={errorMessage.length > 0}
                    >
                        Agregar Tarea
                    </button>
                </div>
            </div>

            <div className='col-5'>
                <h5>Lista de Tareas</h5>
                {projectCheckpoint.tasks.length === 0 && (
                    <p className='text-muted'>No hay tareas creadas...</p>
                )}
                {projectCheckpoint.tasks.length > 0 && (
                    <ul>
                        {projectCheckpoint.tasks.map((task, i) => (
                            <Row key={i} className='g-2 p-1'>
                                <Col xxl={12} lg={6}>
                                    <div className='border rounded border-dashed p-1'>
                                        <div className='d-flex align-items-center'>
                                            <div className='flex-shrink-0 me-3'>
                                                <div key={i} className='avatar-sm'>
                                                    <div className='avatar-title bg-light text-primary rounded fs-24'>
                                                        <i className='ri-booklet-line'></i>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='flex-grow-1 overflow-hidden'>
                                                <h5 className='fs-13 mb-0'>
                                                    <Link
                                                        to='#'
                                                        className='text-body text-truncate d-block'
                                                    >
                                                        <li key={i}>{task.task}</li>
                                                    </Link>
                                                </h5>
                                                <div className='text-muted'>
                                                    {task.comments} - {'   '}
                                                    {task.estimatedDate}
                                                </div>
                                            </div>
                                            <div className='flex-shrink-0 ms-2'>
                                                <div className='d-flex gap-1'>
                                                    <button
                                                        type='button'
                                                        className='btn btn-icon text-muted btn-sm fs-18'
                                                        onClick={() =>
                                                            handleRemoveTask(i)
                                                        }
                                                    >
                                                        <i className='ri-close-line'></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
}
